import { LitElement, html, css } from "lit";
export class List extends LitElement {
    render() {
        return html `<slot></slot>`;
    }
}
List.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      gap: 0;
      width: 100%;
    }
  `;
customElements.define("ds-list", List);
